module.exports = __webpack_public_path__ + "img/Spark.02dd78b6.jpg";